module.exports = __webpack_public_path__ + "static/img/5.3b30bbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Todo-riesgo-empresarial/5.png
// module id = Jiwd
// module chunks = 0